import { render, staticRenderFns } from "./SampleBbs.vue?vue&type=template&id=389eeb30"
import script from "./SampleBbs.vue?vue&type=script&lang=js"
export * from "./SampleBbs.vue?vue&type=script&lang=js"
import style0 from "./SampleBbs.vue?vue&type=style&index=0&id=389eeb30&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('389eeb30')) {
      api.createRecord('389eeb30', component.options)
    } else {
      api.reload('389eeb30', component.options)
    }
    module.hot.accept("./SampleBbs.vue?vue&type=template&id=389eeb30", function () {
      api.rerender('389eeb30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/SampleBbs.vue"
export default component.exports